import React from 'react';

const LoaderInline = ({ text = '', loaderStyle = 'border-[#BC6ED3]' }) => (
  <div className="flex flex-col items-center justify-center py-2 min-h-[56px]">
    <div className={`animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 ${loaderStyle}`}></div>
    {text && <p className="mt-2 text-gray-600 text-sm">{text}</p>}
  </div>
);

export default LoaderInline;
